export function assetUrl(path = '') {
  if (!path) return path;
  if (/^(?:https?:)?\/\//i.test(path) || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }
  if (!path.startsWith('/')) {
    return path;
  }

  const base = process.env.PUBLIC_URL || '';
  return `${base}${path}`;
}

export default assetUrl;
